export var EnumDateFormat = /*#__PURE__*/ function (EnumDateFormat) {
    EnumDateFormat["DateRangeUtcWithTime"] = "yyyy-MM-dd HH:mm";
    EnumDateFormat["DateRangeWithoutTime"] = "yyyy-MM-dd";
    EnumDateFormat["DateRangeLocalWithTime"] = "YYYY-MM-DD HH:mm";
    EnumDateFormat["YearMonthDay"] = "YYYY-MM-DD";
    EnumDateFormat["ChartXAxisFormat"] = "{value:%Y-%m-%d %H:%M}";
    EnumDateFormat["YearMonthDayTime"] = "YYYY-MM-DD HH:MM";
    EnumDateFormat["CommonDate"] = "YYYY-MM-DD HH:mm:ss";
    return EnumDateFormat;
}({});
